import React, {useEffect, useRef, useState} from 'react'
import {karticaRolneModel} from '../../../models/KarticaRolneModel'

const KarticaRolnePdfButton = ({data}: {data: karticaRolneModel}) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const urls = useRef<string[]>([])
  useEffect(() => () => urls.current.forEach((url) => URL.revokeObjectURL(url)), [])

  const openPdf = async () => {
    // Open during the click so mobile browsers do not block the asynchronous PDF.
    const tab = window.open('', '_blank')
    if (!tab) {
      setError('Dozvolite otvaranje nove kartice i pokušajte ponovo.')
      return
    }
    tab.opener = null
    tab.document.title = `Kartica rolne ${data.rolnaInfo.ReprMatId}`
    tab.document.body.textContent = 'Priprema PDF dokumenta…'
    setLoading(true)
    setError('')
    try {
      const {createKarticaRolnePdf} = await import('./KarticaRolnePdf')
      const blob = await createKarticaRolnePdf(data)
      if (!tab.closed) {
        const url = URL.createObjectURL(blob)
        urls.current.push(url)
        tab.location.replace(url)
      }
    } catch {
      tab.close()
      setError('PDF nije kreiran. Pokušajte ponovo.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <button
        type='button'
        className='btn btn-light-primary'
        onClick={openPdf}
        disabled={loading}
        aria-label='Otvori PDF kartice rolne u novoj kartici'
      >
        <i className='bi bi-file-earmark-pdf fs-3 me-2' aria-hidden='true' />
        {loading ? 'Priprema PDF-a…' : 'PDF'}
      </button>
      {error && (
        <div className='text-danger fs-7 mt-2' role='alert'>
          {error}
        </div>
      )}
    </div>
  )
}

export default KarticaRolnePdfButton
